module.exports = __webpack_public_path__ + "static/media/nodi.b7d9e806.png";